import React from 'react';

const Footer = () => {
    const date = new Date();
    const year = date.getFullYear();
    
    return (
        <footer>
            <p className='copyright'>{`Copyright Christian Arneson ${year}`}</p>
        </footer>
    )
}

export default Footer;